import { notification } from 'antd';
import { AxiosError } from 'axios';

import { initSnapSuccessAction } from 'containers/Snaps/Snap/store';

import { ApiError, SnapDetails } from 'codegen';
import { IDataResponse } from 'types';

import { getErrorInfo } from './helpers';

notification.config({ top: 150 });

export const handleCompleteError = (error: AxiosError<ApiError>) => {
  const { title, description } = getErrorInfo(error.response?.data.message);

  notification.error({
    message: title,
    placement: 'top',
    className: 'bg-[#FFF1F0]',
    description,
    key: 'complete-error',
  });
};

export const handleCompleteSuccess = ({ data }: IDataResponse<SnapDetails>) => {
  initSnapSuccessAction(data);

  notification.success({
    key: 'complete-success',
    placement: 'top',
    message: 'Success!',
    duration: 10,
    description: 'Unissued snap matches are successfully submitted. Please note that it may take some time to complete the processing.',
  });
};
